<div class="flex h-full min-h-0 min-w-0 flex-col overflow-hidden px-3 pt-3">
  <div class="flex shrink-0 flex-col gap-2 md:flex-row md:items-center">
    <div class="flex min-w-0 items-center gap-2 md:contents">
      <h1
        class="m-0 flex min-w-0 items-center gap-2 text-[30px] font-bold leading-none text-white md:text-[40px] md:leading-tight"
      >
        <span>{{ title | translate }}</span>
        <span class="rounded-full bg-white/20 px-2 py-0.5 text-sm font-semibold">{{ totalCount }}</span>
      </h1>

      <div class="ml-auto flex shrink-0 items-center gap-2 md:hidden">
        <app-button
          btnType="icon"
          class="relative block shrink-0"
          [ariaLabel]="'filters' | translate"
          [matTooltip]="activeFilterName || filterChipName || ('filters' | translate)"
          (onChangeClick)="openFiltersSidebar()"
        >
          <app-icon>filter_list</app-icon>
          @if (hasActiveFilters) {
            <span aria-hidden="true" class="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-emerald-400 ring-2 ring-slate-900"></span>
          }
        </app-button>

        <button
          type="button"
          class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border-0 bg-transparent p-0 text-white transition-colors hover:bg-white/10 active:bg-white/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/50"
          [attr.aria-label]="'settings' | translate"
          [cdkMenuTriggerFor]="settingsMenu"
        >
          <app-icon class="!text-[28px] !h-7 !w-7 !leading-7 !text-white">settings</app-icon>
        </button>
      </div>
    </div>

    <div class="flex min-w-0 items-center gap-2 md:contents">
      <app-button
        class="shrink-0"
        [customClass]="'max-md:!h-11 max-md:!w-11 max-md:!min-w-11 max-md:!px-0 md:px-2'"
        [disabled]="true"
        (onChangeClick)="onCreate()"
      >
        <span class="flex items-center gap-1 text-sm font-semibold leading-none">
          <app-icon class="max-md:!text-[24px] max-md:!h-6 max-md:!w-6 max-md:!leading-6">add</app-icon>
          <span class="max-md:hidden">{{ 'create' | translate }}</span>
          <app-icon class="max-md:hidden">expand_more</app-icon>
        </span>
      </app-button>

      <app-button
        class="min-w-0 flex-1 md:flex-none"
        [btnType]="'stroked'"
        [customClass]="'funnel-filter-btn w-full max-w-full max-md:!px-3 md:w-auto'"
        [disabled]="isFunnelsLoading || isSavingFunnel"
        [cdkMenuTriggerFor]="funnelMenu"
      >
        <span class="flex min-w-0 items-center gap-2">
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">filter_list</app-icon>
          <span class="min-w-0 truncate text-sm font-semibold">{{ funnelName || ('general_funnel' | translate) }}</span>
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">expand_more</app-icon>
        </span>
      </app-button>

    </div>

    <app-button
      btnType="icon"
      class="relative block shrink-0 max-md:hidden"
      [ariaLabel]="'filters' | translate"
      [matTooltip]="activeFilterName || filterChipName || ('filters' | translate)"
      (onChangeClick)="openFiltersSidebar()"
    >
      <app-icon>filter_list</app-icon>
      @if (hasActiveFilters) {
        <span aria-hidden="true" class="absolute right-1 top-1 h-2 w-2 rounded-full bg-emerald-400"></span>
      }
    </app-button>

    <div class="ml-auto flex shrink-0 items-center gap-2 max-md:hidden">
      @if (funnelViewers.length) {
        <app-board-v3-presence-avatars
          [viewers]="funnelViewers"
          [showDropdown]="true"
        />
      }

      <app-button [btnType]="'icon'" [cdkMenuTriggerFor]="settingsMenu">
        <app-icon>settings</app-icon>
      </app-button>
    </div>
  </div>

  @if (isSelectionMode) {
    <div class="mt-2 flex shrink-0 flex-wrap items-center gap-2 rounded-xl bg-white px-3 py-2 shadow-sm">
      <span class="flex min-w-0 items-center gap-2 text-sm font-semibold text-gray-800">
        <app-icon class="!text-[20px] !h-5 !w-5 !leading-5 text-blue-600">check_box</app-icon>
        <span class="truncate">{{ 'board_v3_selected_cards_count' | translate: { count: selectedCount } }}</span>
      </span>

      <div class="ml-auto flex shrink-0 items-center gap-2">
        <button
          type="button"
          class="flex h-9 items-center gap-1.5 rounded-lg! border border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-300"
          [disabled]="isBulkActionRunning || !canMergeSelectedCards"
          [title]="(canMergeSelectedCards ? 'board_v3_merge_cards_title' : 'board_v3_merge_cards_not_enough') | translate"
          (click)="openMergeSelectedCardsSidebar()"
        >
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">merge_type</app-icon>
          <span>{{ 'board_v3_merge_cards_confirm' | translate }}</span>
        </button>

        <button
          type="button"
          class="flex h-9 items-center gap-1.5 rounded-lg! border border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-300"
          [disabled]="isBulkActionRunning"
          (click)="openMoveSelectedCardsSidebar()"
        >
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">drive_file_move</app-icon>
          <span>{{ 'board_v3_move_card' | translate }}</span>
        </button>

        <button
          type="button"
          class="flex h-9 items-center gap-1.5 rounded-lg! border border-red-200 bg-white px-3 text-sm font-medium text-red-600 hover:bg-red-50 disabled:cursor-not-allowed disabled:text-red-300"
          [disabled]="isBulkActionRunning"
          (click)="onDeleteSelectedCards()"
        >
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">delete_outline</app-icon>
          <span>{{ 'delete' | translate }}</span>
        </button>

        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg! text-gray-500 hover:bg-gray-100"
          [attr.aria-label]="'board_v3_clear_selection' | translate"
          [title]="'board_v3_clear_selection' | translate"
          (click)="clearSelection()"
        >
          <app-icon class="!text-[20px] !h-5 !w-5 !leading-5">close</app-icon>
        </button>
      </div>
    </div>
  }

  <ng-template #settingsMenu>
    <div cdkMenu class="min-w-56 rounded-xl border border-gray-100 bg-white p-2 shadow-lg">
      @for (item of settingsMenuItems; track $index) {
        @if (item.divider) {
          <div class="my-1 h-px bg-gray-100"></div>
        } @else {
          <button
            type="button"
            cdkMenuItem
            class="flex w-full items-center gap-3 rounded-lg! px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
            (click)="onSettingsAction(item.id!)"
          >
            <app-icon class="!text-[20px] !h-[20px] !w-[20px] !leading-none text-gray-500">{{ item.icon }}</app-icon>
            <span>{{ item.label | translate }}</span>
          </button>
        }
      }
    </div>
  </ng-template>

  <ng-template #funnelMenu>
    <div cdkMenu class="min-w-64 rounded-xl border border-gray-100 bg-white p-2 shadow-lg">
      @for (funnel of funnels; track funnel.id) {
        <div class="flex items-center gap-1 rounded-lg hover:bg-gray-50">
          <button
            type="button"
            cdkMenuItem
            class="flex min-w-0 flex-1 items-center gap-2 px-3 py-2 text-left text-sm text-gray-700"
            (click)="onSelectFunnel(funnel)"
          >
            <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none text-gray-500">
              {{ funnel.id === funnelId ? 'check' : 'account_tree' }}
            </app-icon>
            <span class="truncate">{{ funnel.name }}</span>
            @if (funnel.status === FUNNEL_STATUS.GENERAL) {
              <span class="ml-auto text-xs text-gray-400">{{ 'board_v3_general_funnel_badge' | translate }}</span>
            }
          </button>
          <button
            type="button"
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded text-gray-400 hover:bg-gray-200 hover:text-gray-700"
            [attr.aria-label]="'board_v3_edit_funnel' | translate"
            (click)="onEditFunnel(funnel); $event.stopPropagation()"
          >
            <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">edit</app-icon>
          </button>
          <button
            type="button"
            class="mr-1 flex h-7 w-7 shrink-0 items-center justify-center rounded text-gray-400 hover:bg-red-50 hover:text-red-600"
            [attr.aria-label]="'board_v3_delete_funnel' | translate"
            (click)="onDeleteFunnel(funnel); $event.stopPropagation()"
          >
            <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">delete</app-icon>
          </button>
        </div>
      }
      @if (funnels.length) {
        <div class="my-1 h-px bg-gray-100"></div>
      }
      <button
        type="button"
        cdkMenuItem
        class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-blue-600 hover:bg-blue-50"
        (click)="onCreateFunnel()"
      >
        <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">add</app-icon>
        <span>{{ 'create_funnel' | translate }}</span>
      </button>
    </div>
  </ng-template>

  @if (isBoardLoading) {
    <div class="mt-3 flex flex-1 flex-col items-center justify-center gap-3 text-sm text-gray-400">
      <div class="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-blue-500"></div>
      <span>{{ 'board_v3_loading_funnel' | translate }}</span>
    </div>
  } @else if (!funnels.length) {
    <div class="mt-3 flex flex-1 flex-col items-center justify-center gap-3">
      <span class="text-sm text-gray-400">{{ 'board_v3_no_funnels' | translate }}</span>
      <app-button (onChangeClick)="onCreateFunnel()">
        <span class="flex items-center gap-1 text-sm font-semibold leading-none">
          <app-icon>add</app-icon>
          <span>{{ 'create_funnel' | translate }}</span>
        </span>
      </app-button>
    </div>
  } @else if (!columns.length) {
    <div class="mt-3 flex flex-1 flex-col items-center justify-center gap-3">
      <span class="text-sm text-gray-400">{{ 'board_v3_no_stages' | translate }}</span>
      <app-button (onChangeClick)="onCreateColumn()">
        <span class="flex items-center gap-1 text-sm font-semibold leading-none">
          <app-icon>add</app-icon>
          <span>{{ 'board_v3_add_stage' | translate }}</span>
        </span>
      </app-button>
    </div>
  } @else {
    <div class="crm-scroll -mx-3 mt-3 min-h-0 min-w-0 flex-1 snap-x snap-mandatory scroll-px-3 scroll-smooth overflow-x-auto overflow-y-hidden overscroll-x-contain px-3">
      <div class="flex h-full min-h-0 flex-row items-stretch gap-2">
        @for (column of columns; track column.id) {
          <div class="flex h-full w-full basis-full min-h-0 shrink-0 snap-center snap-always flex-col overflow-hidden md:w-[320px] md:basis-[320px]">
            <app-board-v3-column-header
              [column]="column"
              [localCount]="cardsFor(column.id).length"
              [selectionMode]="isSelectionMode"
              [allSelected]="isColumnFullySelected(column.id)"
              [someSelected]="isColumnPartiallySelected(column.id)"
              (onAdd)="onColumnAdd($event)"
              (onMore)="onColumnMore($event)"
              (onClear)="onColumnClear($event)"
              (onSelectAll)="onToggleColumnSelection($event)"
            />
            <ng-template #quickCreateTemplate>
              <app-board-v3-quick-create-card
                [column]="column"
                [funnelId]="funnelId"
                [defaultCurrency]="selectedFunnelCurrency"
                [managers]="managers"
                [createFields]="funnelCreateFields"
                [fieldDefs]="fields"
                (closeChange)="activeCreateColumn = null"
                (settingsClick)="openQuickCreateSettingsSidebar()"
                (created)="onQuickCardCreated($event)"
              />
            </ng-template>
            <app-board-v3-column-body
              class="flex min-h-0 flex-1 flex-col"
              [columnId]="column.id"
              [cards]="cardsFor(column.id)"
              [connectedTo]="connectedTo(column.id)"
              [canMoveCards]="isMobile && columns.length > 1"
              [viewFields]="funnelViewFields"
              [allFields]="fields"
              [hasMore]="columnPagination[column.id]?.hasMore ?? false"
              [isLoading]="columnPagination[column.id]?.loading ?? false"
              [quickCreateTemplate]="activeCreateColumn?.id === column.id ? quickCreateTemplate : null"
              [selectionMode]="isSelectionMode"
              [selectedCardIds]="selectedCardIds"
              (cardSelectionToggle)="onCardSelectionToggle($event)"
              (cardDrop)="onCardDrop($event, column)"
              (cardDragStart)="onCardDragStart()"
              (cardDragEnd)="onCardDragEnd()"
              (cardClick)="onCardClick($event)"
              (cardDelete)="onDeleteCard($event)"
              (cardMoveClick)="openMoveCardSidebar($event)"
              (chatClick)="onOpenChat($event)"
              (loadMore)="onLoadMore(column)"
            />
          </div>
        }
        <div class="w-3 shrink-0" aria-hidden="true"></div>
      </div>
    </div>

    <app-board-v3-drag-action-footer
      [columns]="columns"
      [boardColumnIds]="boardColumnIds"
      [isDragging]="isCardDragging"
      (cardDrop)="onDragActionDrop($event.event, $event.column)"
      (deleteDrop)="onDeleteDragActionDrop($event)"
    />
  }
</div>
